// Action key that carries API call info interpreted by HTTP Redux middleware.
export const CALL_HTTP_API = "Call HttpAPI";

// Action key that carries API call info interpreted by Socket Redux middleware.
export const CALL_SOCKET_API = "Call SocketAPI";

// Action key that carries API call info interpreted by Socket Redux middleware.
export const CALL_MAXMD_API = "Call MaxmdAPI";
